import { languageMap } from ".."
import "./html"

languageMap.etlua = languageMap.html
